import { isRouteErrorResponse, useRouteError } from "react-router";
import * as Sentry from "@sentry/react";
import { ForbiddenError } from "@/api/client";
import { IconLock } from "@tabler/icons-react";

export function RouteErrorBoundary() {
  const error = useRouteError();

  if (!(error instanceof ForbiddenError)) {
    Sentry.captureException(error);
  }

  if (error instanceof ForbiddenError) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
          <IconLock className="h-6 w-6 text-destructive" />
        </div>
        <h2 className="text-lg font-semibold mb-1">Access Denied</h2>
        <p className="text-sm text-muted-foreground max-w-sm">
          Your account doesn't have permission to view this page.
          Contact an administrator if you believe this is a mistake.
        </p>
      </div>
    );
  }

  const message = error instanceof Error
    ? error.message
    : isRouteErrorResponse(error)
      ? `${error.status} ${error.statusText}`
      : "An unexpected error occurred";

  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <h2 className="text-lg font-semibold mb-1">Something went wrong</h2>
      <p className="text-sm text-muted-foreground max-w-sm">{message}</p>
    </div>
  );
}
